import { InjectionToken } from '@angular/core';

export let ENV = new InjectionToken('env.variables');
